import type { InstagramField } from "./fields";

export function fieldError(field: InstagramField, value: string) {
	const filled = value.trim() !== "";

	if (!filled) {
		if (field.optional) {
			return null;
		}

		return "Campo obrigatório";
	}

	if (field.kind === "tel" && value.replaceAll(/\D/gu, "").length < 10) {
		return "Número inválido";
	}

	return null;
}
